/* StatusMessageRenderer.js */

"use strict";
//const ConfirmDialogComponent = require('../confirmdialogcomponent/ConfirmDialogComponent');

class StatusMessageRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("status-message-gl");
        this._rootElem.component = this._model;
        this._messageElem = null;
        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown(){
        let prom = new Promise((resolve)=>{
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            //TODO set all class members to undefined here
            resolve();
        });
        return prom;
    }
    _registerListeners(){
        this._model.on("Shutdown",this._onShutdown = this._onShutdown.bind(this));
    }
    _unregisterListeners(){
        this._model.removeListener("Shutdown",this._onShutdown);
    }
    _renderMessage(){
        let messages = this._model._messageHistory;
        if (!messages || !this._model._showMessages){
            messages = [];
        }

        //clear
        if(this._messageElem) {
            this._messageElem.remove();
            this._messageElem = undefined;
        }

        this._messageElem = document.createElement('div');
        this._rootElem.appendChild(this._messageElem);

        messages.forEach(error => {
            const errorBox = document.createElement('span');
            this._messageElem.appendChild(errorBox);
            errorBox.innerText = error.msg;
            if(error.isError) {
                errorBox.classList.add('error');
            } else {
                errorBox.classList.remove('error');
            }
            setTimeout(() => {
                errorBox.remove();
                this._messageElem = undefined;
                this._model.clear();
            }, 8000);
        });
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render(){
        let prom = new Promise((resolve)=>{
            this._renderMessage();
            resolve();
        });
        return prom;
    }
    get rootElement(){
        return this.getRootElement();
    }
    getRootElement(){
        return this._rootElem;
    }
    get model(){
        return this.getModel();
    }
    getModel(){
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    //TODO Private Render Methods here
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onShutdown(){
        this._shutdown();
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports=StatusMessageRenderer;